import {
    ChangeDetectorRef, Component,
    ElementRef, EventEmitter, Input, OnDestroy, OnInit,
    Output, Renderer, ViewChild
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MaskPipe } from 'ngx-mask';
import { Modal } from 'ngx-modal';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../../environments/environment';
import { ContactTypeValue } from '../../../common/enums/contact-type.value.enum';
import { Country } from '../../../shared/interface/country.interface';
import { State } from '../../../shared/interface/state.interface';
import { CommonService } from '../../../shared/services/common.service';
import { MessageService } from '../../../shared/services/message.service';
import { CountrySuffixZipCodes } from '../../constants/country-suffix-zipcodes';
import { AddressError } from '../../enums/address-error.enum';
import { AddressOptions, AddressSchemaFormFrameworkType } from '../../enums/address-type.enum';
import { NotificationType } from '../../enums/notification-types.enum';
import { SchemaProperty } from '../../enums/schema-property.enum';
import { Address, VerifyAddressErrorCode } from '../../interface/address';
import { AddressResponse, JsonSchemaFormOptions } from '../../interface/addressResponse';
import { CheckoutConfig } from '../../interface/checkout-config.interface';
import { ParticipatingCountries } from '../../interface/participating-countries.interface';
import { Option, SearchAddressModelResponse } from '../../interface/search-address-model-response.interface';
import { AddressService } from '../../services/address.service';
import { CheckoutConfigService } from '../../services/checkout-config.service';
import { CustomerService } from '../../services/customer.service';
import { CustomMaskTextboxComponent } from '../../widgets/custom-mask-textbox.widget';
import { CustomSelectWidgetComponent } from '../../widgets/custom-select.widget';
import { TranslateKey } from './../../../common/pipes/translate-key.pipe';

@Component({
    selector: 'app-pudo-address',
    templateUrl: '../../templates/template1/views/address/pudo-address.component.html',
    styleUrls: [
        '../../templates/template1/themes/default/less/address.component.less']
})

export class PudoAddressComponent implements OnInit, OnDestroy {
    address: Address;
    isoCountryCode: string;
    jsonFormObject: any;
    originalJsonFormObject: any;
    selectedFrameWork = AddressSchemaFormFrameworkType.BOOTSTRAP4;
    addressVerificationForm = false;
    responseCodes: AddressResponse[] = [];
    liveFormData: Address;
    countries: Country[];
    states: State[];
    countryId: number;
    originalAddress: Address;
    suggestedAddress: Address;
    errorCodes: any;
    errorCodesLength = 0;
    isModalOpen = false;
    jsonFormOptions: JsonSchemaFormOptions = {
        addSubmit: true, // Add a submit button if layout does not have one
        loadExternalAssets: false, // Load external css and JavaScript for frameworks
        debug: false,
        setSchemaDefaults: true,
        returnEmptyFields: false,
    };
    customWidgets = {
        'custom-select-widget': CustomSelectWidgetComponent,
        'custom-mask-widget': CustomMaskTextboxComponent
    };
    selectedAddressType = AddressOptions.SUGGESTEDADDRESS;
    submitAddressSubscription: Subscription;
    editSubscription: Subscription;
    showAddressVerification: boolean;
    displayAddressBlock = true;
    liveFormStatus: boolean;
    validationMessageInitialHide = true;
    isAddressFormChanged: boolean;
    checkoutConfig: CheckoutConfig;
    participatingCountries: ParticipatingCountries[];
    searchAddressOptions: Option[];
    customSelectSubscription: Subscription;
    enableAddressFieldSubscription: Subscription;
    pollCount = 0;
    maxpollCount = 1;
    @ViewChild('addressModal') addressModal: Modal;

    @Input() schemaUrl: string;
    @Input() countryCode: string;
    @Input() onCountryChange: boolean;
    @Input() isEnableVerifyButton: boolean;
    @Input() isShippingAddressSchemaform:boolean;
    @Input() storeConfig:any;
    @Input() preloadAddress: Address;
    @Input() skipAddressVerification: boolean;
    @Input() isInputChangeRequired: boolean;
    @Input() schemaClass: string;
    @Input() isChangeRegisteredAddress: boolean;
    @Input() participatingCountry: ParticipatingCountries;
    @Input() isFromFboProfile: boolean;
    @Output() addressSubmit = new EventEmitter<any>();
    // this is used to send info of displaying address verification
    // as of now we are using in personal information section
    @Output() addressVerificationInfo = new EventEmitter<boolean>();

    @Output() addressSubmitOnInputChange = new EventEmitter<any>();
    @Output() addressHidden = new EventEmitter<boolean>();
    @Output() addressInputChanged = new EventEmitter<boolean>();
    @Output() cancelChangeAddress = new EventEmitter<boolean>();
    @Output() isDisplaySearchAddressSection = new EventEmitter<boolean>();
    @Output() addressIsValid = new EventEmitter<any>();
    resetFormDataSubscription: Subscription;

    constructor(
        private _addressService: AddressService,
        private elementRef: ElementRef,
        private _renderer: Renderer,
        private _commonService: CommonService,
        private _customerService: CustomerService,
        private _checkoutConfigService: CheckoutConfigService,
        private chRef: ChangeDetectorRef,
        private _translateService: TranslateService,
        private _maskPipe: MaskPipe,
        private messageService: MessageService,
        private _translateKey: TranslateKey,
        private _appMessageService: MessageService,
    ) { }

    ngOnInit() {

        this.isoCountryCode = this.countryCode;
        this.checkoutConfig = this._checkoutConfigService.getSettings(this.countryCode, null);
        if (this.isShippingAddressSchemaform && this.checkoutConfig && this.checkoutConfig.changeSchemaFormOnCountryChange) {
            this.changeSchemaOnCountryChange(true);
        }
        this.getJsonSchema();
        this.rebindForm();
        this.getCountriesLookup();
        this.getCustomSelectOption();
        this.enableAddressFields();
        this._commonService.getEmitter('newAddressForm').subscribe((response: any) => {
            this.reloadJsonObject();
        });
        if (this.checkoutConfig && this.checkoutConfig.loadParticipatingCountries) {
            this.getParticipatingCountries();
        }
        this.getSubmitAddress();
    }

    /**
     * @description new Address Schema Form
     * @date 2018-07-20
     * @private
     * @memberof AddressComponent
     */
    private reloadJsonObject(): void {
        this.address = null;
        this.jsonFormObject = {};
        this.jsonFormObject.data = {};
        this.jsonFormObject = this.getParsedSchemaFormJson(this.originalJsonFormObject);
    }

    /**
     * @param {Address} data
     * @memberof AddressNewComponent
     */
    onChanges(data: Address) {
        this.liveFormData = data;
    }

    /**
     * @description it will trigger when we
     * change any input value in form
     * @date 2018-08-02
     * @memberof AddressComponent
     */
    changeInputValue(event: any): void {
        // To notify address is changed by the User
        this.addressInputChanged.emit(true);
        this.messageService.setAddressSaved(false);
        if (this.addressVerificationForm) {
            this.isAddressFormChanged = true;
        }
        this.showAddressVerification = true;
        if ($('.remove-disable').attr('disabled')) {
            $('.remove-disable').removeAttr('disabled');
        }
        // logic to enable submit button in popup.
        this.jsonFormObject = this.enableVerifyButton();
        if (this.isInputChangeRequired) {
            this.addressSubmitOnInputChange.emit(this.prepareNewAddress(this.liveFormData));
        }
    }

    /**
     * @description method to get countries lookup
     * @memberof AddressNewComponent
     */
    getCountriesLookup() {
        const allCountries= JSON.parse(localStorage.getItem("appadmin.Countries"));
        if (allCountries && allCountries.length > 0) {
                this.countries = allCountries;
                this.countryId = this.countries
                    .filter((x: Country) => x.isocodeThree === this.isoCountryCode.toUpperCase())[0].countryId;
                if (this.countryId) {
                    this.getAllStatesByCountry();
                }
            }
    }

    /**
     * @description
     * @date 2020-03-23
     * @private
     * @memberof AddressNewComponent
     */
    private getParticipatingCountries(): void {
        this._customerService.getParticipatingCountries(this.countryCode)
            .subscribe(response => {
                if (response && response.length > 0) {
                    this.participatingCountries = response;
                }
            });
    }

    /**
     * to get latitude and longitude info for GBR
     * @returns void
     */
    getSpatialInfo(): void {
        const postalCode = this.address.zip || this.address.postalCode;
        const countryCode = this.address.country || this.address.countryCode;
        this._addressService.getSpatialInfo(postalCode, countryCode)
            .subscribe(response => {

            if(response && response.validations.length>0){
                if(response.validations[0].message && response.validations[0].name === AddressError.API_REQUEST_DAILY_LIMIT_EXCEED){
                    let message:String = response.validations[0].message;
                    let limit:String = message.replace(/[^0-9]/g,'');
                    let dailyLimitExceedMessage = this._translateService.get('common.'+'The Daily Limit of ||requestLimit|| is exceeded and address verification will not function')['value'];
                    dailyLimitExceedMessage = this._translateKey.transform(dailyLimitExceedMessage,{requestLimit: limit});
                     this._commonService.setNotification('',dailyLimitExceedMessage,NotificationType.ERROR,0,true,80);
                }
            }
                if (response) {
                    if (this.address) {
                        this.address.latitude = response.latitude;
                        this.address.longitude = response.longitude;
                        this.address = this.prepareNewAddress(this.address);
                        if (response.success) {
                            this.address.addressVerified = true;
                        }
                    }
                    this.addressSubmit.emit(this.address);
                }
            });
    }

    // /**
    //  * get selected address
    //  * @returns void
    //  */
    rebindAddressInfo(address: Address): void {
        this.address = { ...this.address, ...address };
        this.mapNameAndPhoneFields();
        this.displayAddressBlock = false;
        if (this.address) {
            this.skipAddressVerification = true;
            this.mapSearchAddress(address);
        }
        this.searchAddressOptions = [];
        setTimeout(() => {
            this.jsonFormObject =
                this.getParsedSchemaFormJson(this.originalJsonFormObject);
            this.maskZipCode(); 
            this.jsonFormObject.data = this.address;
            this.displayAddressBlock = true;
            this.changeInputValue(address);
            this.disableAddressFields(true);
            this.liveFormData = this.address;
            if (this.isInputChangeRequired) {
                this.addressSubmitOnInputChange.emit(this.prepareNewAddress(this.liveFormData));
            }
            if(!this.isFromFboProfile) {
            this.addressSubmit.emit(this.prepareAddressObject(this.address));
            }
            this.disableCountryDropdownForPudoPickup();
            //this.addressSubmit.emit(this.address);
        }, 0);
    }
    mapNameAndPhoneFields(): void {
        if (this.liveFormData && this.address) {
            this.address.firstName = this.liveFormData.firstName;
            this.address.middleName = this.liveFormData.middleName;
            this.address.lastName = this.liveFormData.lastName;
            this.address.phone = this.liveFormData.phoneNumber;
            this.address.phoneType = this.liveFormData.phoneType;
            this.address.email = this.liveFormData.email ? this.liveFormData.email : null;
        }
    }
    mapSearchAddress(address?: Address): void {
        if (this.address.city) {
            const city = this.address.city;
            if (this.participatingCountries && this.participatingCountries.length > 0) {
                const participatingCountry = this.participatingCountries
                    .find(x => x.name.toLowerCase() === city.toLowerCase());
                if (participatingCountry) {
                    address.country = participatingCountry.isocodeThree;
                    address.countryId = participatingCountry.countryId;
                }
            } else {
                address.country = this.isoCountryCode;
            }
        }
        if (!this.address.phoneType) {
            this.address.phoneType = ContactTypeValue.MOBILE;
        }
        address = this.getStateByStateName(address);
        if (address.stateCode) {
            this.address.stateCode = address.stateCode;
            this.address.state = address.state;
        }
        if (address.country) {
            const country = this.countries.find(x => x.isocodeThree.toLowerCase()
                === address.country.toLowerCase());
            if (country) {
                this.address.country = country.countryId ? String(country.countryId) : '';
                this.address.countryId = country.countryId;
                this.address.countryCode = country.isocodeThree;
                this.address.countryCodeTwo = country.isocodeTwo;
                this.getStatesByCountry(country.countryId);
            }
        }
        this.address.zip = this.address.postalCode;
        this.address.addressVerified = address.validAddress;
    }

    /**
     * get search address options info
     * @returns void
     */
    getSearchAddressOptionsInfo(searchAddressOptions: Option[]): void {
        this.searchAddressOptions = searchAddressOptions;
    }

    /**
     * getMaskedZipCode()
     * @param zipCode
     */
    getMaskedZipCode(zipCode: string): string {
        if (this.jsonFormObject && this.jsonFormObject.schema.properties && zipCode) {
            if (this.jsonFormObject.schema.properties.zip
                    && this.jsonFormObject.schema.properties.zip.maskFormat && zipCode) {
                    zipCode = this._maskPipe.transform(zipCode, this.jsonFormObject.schema.properties.zip.maskFormat);
            }
        }
        return zipCode;
    }

    /**
    * To verify address when we enter address manually for GBR
    * @returns void
    */
    verifyAddressByDisplayName(addressRequestObj: Address): void {
        addressRequestObj.zip = addressRequestObj.zip.toUpperCase();
        addressRequestObj.postalCode = addressRequestObj.zip.toUpperCase();
        const country = this.getSelectedCountry();
        const displayName = this.prepareDisplayNameByAddress();
        this._addressService.getSearchAddress(country, '', displayName).subscribe((verifyAddressResponse: SearchAddressModelResponse) => {

            if(verifyAddressResponse && verifyAddressResponse.validations.length>0){
                if(verifyAddressResponse.validations[0].message && verifyAddressResponse.validations[0].name === AddressError.API_REQUEST_DAILY_LIMIT_EXCEED){
                    let message:String = verifyAddressResponse.validations[0].message;
                    let limit:String = message.replace(/[^0-9]/g,'');
                    let dailyLimitExceedMessage = this._translateService.get('common.'+'The Daily Limit of ||requestLimit|| is exceeded and address verification will not function')['value'];
                    dailyLimitExceedMessage = this._translateKey.transform(dailyLimitExceedMessage,{requestLimit: limit});
                     this._commonService.setNotification('',dailyLimitExceedMessage,NotificationType.ERROR,0,true,80);
                }
             }
            if (verifyAddressResponse) {
                if (verifyAddressResponse.address) {
                    if (verifyAddressResponse.address && (verifyAddressResponse.address.postalCode || verifyAddressResponse.address.zip)) {
                        const zipCode = this.getMaskedZipCode(verifyAddressResponse.address.postalCode
                             || verifyAddressResponse.address.zip);
                        verifyAddressResponse.address.zip = zipCode;
                        verifyAddressResponse.address.postalCode = zipCode;
                    }
                    const sameAsSuggestedAddress = this.compareSuggestedVsEntered(verifyAddressResponse.address);
                    if (sameAsSuggestedAddress) {
                        this.navigateByEnteredAddress();
                    } else {
                        this.originalAddress = addressRequestObj;
                        this.originalAddress =
                            this.transformAddressZipCode(this.originalAddress);
                        this.addressVerificationForm = false;
                        this.suggestedAddress = verifyAddressResponse.address;
                        this.suggestedAddress.zip = verifyAddressResponse.address.zip
                            || verifyAddressResponse.address.postalCode;
                        this.suggestedAddress.phone = this.originalAddress.phone
                            ? this.originalAddress.phone : null;
                        this.suggestedAddress.email = this.originalAddress.email
                            ? this.originalAddress.email : null;
                        this.getSchemaFormButton(false);
                        this.loadDesktopOrMobileAddressVerification(true);
                    }
                } else {
                    this.navigateByEnteredAddress();
                }
            }
        });
    }

    /**
       * to get selected country details coutry
       */
    private getSelectedCountry(): Country {
        if (this.address && this.address.country) {
            const countryId = Number(this.address.country);
            let country = this.countries.find(item => item.countryId === countryId);
            if (!country) {
                country = this.countries.find((x: Country) => x.isocodeThree.toLowerCase()
                    === this.countryCode.toLowerCase());
            }
            return country;
        }
    }

    /**
    * to prepare display name by address
    */
    prepareDisplayNameByAddress(): string {
        let displayName = '';
        displayName = this.address.addressLine1 ? displayName
            + this.address.addressLine1 + ',' : displayName;
        displayName = this.address.addressLine2 ? displayName
            + this.address.addressLine2 + ',' : displayName;
        displayName = this.address.addressLine3 ? displayName
            + this.address.addressLine3 + ',' : displayName;
        displayName = this.address.city ? displayName
            + this.address.city + ' ' : displayName;
        displayName = this.address.zip ? displayName
            + this.address.zip : displayName;
        return displayName;
    }

    /**
     * compare suggested address vs enetered address manually
     */
    compareSuggestedVsEntered(address: Address): boolean {
        let suggestedAddress = false;
        if (this.originalAddress && address) {
            if ((this.originalAddress.addressLine1 === address.addressLine1)
                && (this.originalAddress.addressLine2 === address.addressLine2
                    || (!this.originalAddress.addressLine2 && !address.addressLine2))
                && (this.originalAddress.addressLine3 === address.addressLine3
                    || (!this.originalAddress.addressLine3 && !address.addressLine3))
                && this.originalAddress.city === address.city
                && this.originalAddress.zip === address.postalCode
                && this.originalAddress.country.toLowerCase() === address.country.toLowerCase()) {
                suggestedAddress = true;
            }
        }
        if (!address.addressLine1 || !address.city) {
            suggestedAddress = true;
        }
        return suggestedAddress;
    }

    /**
     * to navigate to next based on entered address
     */
    navigateByEnteredAddress(): void {
        this.suggestedAddress = this.originalAddress;
        this.suggestedAddress.zip = this.originalAddress.postalCode
            || this.originalAddress.zip;
        this.suggestedAddress.phone = this.originalAddress.phone
            ? this.originalAddress.phone : null;
        this.suggestedAddress.email = this.originalAddress.email
            ? this.originalAddress.email : null;
        this.selectedAddressType = AddressOptions.SUGGESTEDADDRESS;
        this.selectAddress(true);
    }

    /**
    *Suffixes the Zipcode required for tax calculation
    *
    * @param {Address} address
    * @returns {Address}
    * @memberof AddressNewComponent
    */
    transformAddressZipCode(address: Address): Address {
        if (address && address.countryId === CountrySuffixZipCodes.USACountrySuffixZipCode.countryId) {
            address.zip = (address.zip && address.zip.length === CountrySuffixZipCodes.USACountrySuffixZipCode.zipCodeLength)
                ? (address.zip + '-' + CountrySuffixZipCodes.USACountrySuffixZipCode.defaultSuffixZipCode) : address.zip;
            address.postalCode = (address.postalCode && address.postalCode.length ===
                CountrySuffixZipCodes.USACountrySuffixZipCode.zipCodeLength) ? (address.postalCode + '-' +
                    CountrySuffixZipCodes.USACountrySuffixZipCode.defaultSuffixZipCode) : address.postalCode;
        }
        return address;
    }

    /**
     * @description get states by country
     * @memberof AddressNewComponent
     */
    getAllStatesByCountry() {
        this._customerService.getStatesByCountryId(this.countryId).subscribe((res: State[]) => {
            this.states = res;
        });
    }

    /**
     * @description to get the country specific schema json file
     * @returns void
     */
    getJsonSchema(address?: Address, isEdit?: boolean): void {
        this._addressService.getJsonFormSchema(this.schemaUrl)
            .subscribe((response: any) => {
                this.jsonFormObject = this.getParsedSchemaFormJson(response);
                this.originalJsonFormObject = response;
                this.address = address || this.preloadAddress;
                if (this.address) {
                    if (this.address && this.address.countryId) {
                        this.address.country = String(this.address.countryId);
                        this.getStatesByCountry(this.address.countryId);
                    }
                    this.address.zip = this.address.zip || this.address.postalCode;
                    this.address.phoneNumber = this.address.phoneNumber ?
                        this.maskPhoneNumber(this.address.phoneNumber) : this.address.phone ? this.maskPhoneNumber(this.address.phone): '';
                    this.jsonFormObject.data = this.mapAddressToSchemaFields(this.address);
                    if (this.address.firstName && this.address.lastName && this.address.addressLine1
                        && this.address.city && this.address.stateId
                        && !isEdit && (this.address.addressVerified || this.address.validAddress) && !this.isEnableVerifyButton) {
                        this.jsonFormObject = this.disableVerifyButton();
                    }

                    this.showAddressVerification = isEdit ? isEdit : false;
                }
                if (!this.jsonFormObject.data
                    || (this.jsonFormObject.data
                        && (!this.jsonFormObject.data.state))) {
                    this.jsonFormObject.data.state = '';
                }
                if (!this.jsonFormObject.data
                    || (this.jsonFormObject.data
                        && (!this.jsonFormObject.data.state
                            || !this.jsonFormObject.data.phoneType))) {
                    this.jsonFormObject.data.phoneType = ContactTypeValue.MOBILE;
                }
                if (isEdit) {
                    this.getSchemaFormButton(isEdit);
                }
                this.findErrorElement();
                if (this.checkoutConfig.displaySearchAddressSection) {
                    this.disableAddressFields(true);
                }
                this.disableCountryDropdownForPudoPickup();                              
            }, (error) => {
                if (this.pollCount < this.maxpollCount) {
                this.schemaUrl = 'gbl-mailing-schema-form.json?templateVersion=' + environment.templateVersion;
               if(this.liveFormData &&this.liveFormData.state ){
                    this.liveFormData.state = '';
               }
               if (this.liveFormData) {
                this.liveFormData.countryId = this.countryId;
               }
                this.getJsonSchema(this.liveFormData);
                }
                this.pollCount = this.pollCount + 1;
            });
    }

    /**
    * to get all states by country
    */
    getStatesByCountry(countryId: number): void {
        if (!this.countries) {
            return;
        }
        const selectedCountry = this.countries
            .find((x: Country) => x.countryId === countryId);
        if (selectedCountry) {
            this.isoCountryCode = selectedCountry.isocodeThree.toLowerCase();
            this.countryId = selectedCountry.countryId;
            if (this.countryId) {
                this._customerService.getStatesByCountryId(countryId).subscribe((res) => {
                    this.states = res;
                });
            }
        }
    }

    /**
     * get parsed json form object
     * @param  {any} jsonText
     * @returns any
     */
    getParsedSchemaFormJson(jsonText: any): any {
        let newFormObject: any = null;
        try {
            // Parse entered content as JSON
            newFormObject = JSON.parse(jsonText);
        } catch (jsonError) {
            try {
                // If entered content is not valid JSON,
                // parse as JavaScript instead to include functions
                newFormObject = null;
                /* tslint:disable */
                eval('newFormObject = ' + jsonText);
                /* tslint:enable */

            } catch (javascriptError) {
                return;
            }
        }
        newFormObject = this.getShiipingEmailFieldOptions(newFormObject);
        return newFormObject;
    }

    getShiipingEmailFieldOptions(jsonObject: any): any {
        if (this.isShippingAddressSchemaform && this.storeConfig) {
            const jsonSchemaKeys = Object.keys(jsonObject.schema.properties);
            jsonSchemaKeys.forEach((obj: any) => {
                if (obj.toLowerCase() === SchemaProperty.EMAIL.toLowerCase() && this.storeConfig.enableShippingEmailRequired) {
                    if (!jsonObject.schema.required.includes('email')) {
                        jsonObject.schema.required.push(obj);
                        if (!jsonObject.schema.properties[obj].placeholder.endsWith('*')) {
                            jsonObject.schema.properties[obj].placeholder = jsonObject.schema.properties[obj].placeholder + '*';
                        }
                    }
                } else if (obj.toLowerCase() === SchemaProperty.EMAIL.toLowerCase() && !this.storeConfig.enableShippingEmailRequired) {
                    const emailIndex = jsonObject.schema.required.indexOf(obj);
                    if (emailIndex > -1) {
                        jsonObject.schema.required.splice(emailIndex, 1);
                        if (jsonObject.schema.properties[obj].placeholder.endsWith('*')) {
                            jsonObject.schema.properties[obj].placeholder = jsonObject.schema.properties[obj].placeholder.slice(0, -1);
                        }
                    }
                }
            });
            return this.getTranslatedSchemaData(jsonObject);
        } else {
            return this.getTranslatedSchemaData(jsonObject);
        }
    }
    /** Schema Form Translation
    * @param  {any} jsonObject
    */
    getTranslatedSchemaData(jsonObject: any): any {

        // adding required validation
        if (jsonObject && jsonObject.schema && jsonObject.schema.required) {
            if (this.isChangeRegisteredAddress) {
                jsonObject.schema.required.push(SchemaProperty.COUNTRY);
            }
        }
        // Translate Schema form fields.
        if (jsonObject && jsonObject.schema && jsonObject.schema.properties) {
            const jsonSchemaKeys = Object.keys(jsonObject.schema.properties);
            if (jsonSchemaKeys) {
                jsonSchemaKeys.forEach((obj: any) => {
                    // Translate Schema Form fields.
                    let translatedText = jsonObject.schema.properties[obj].placeholder || jsonObject.schema.properties[obj].selectText;
                    if (translatedText.endsWith('*')) {
                        translatedText = translatedText.slice(0, -1);
                    }
                    let translatedValue = this._translateService.get('schemaform.' + translatedText)['value'];
                    translatedValue = translatedValue ? translatedValue : translatedText;
                    if (jsonObject.schema.required) {
                        if (jsonObject.schema.required.indexOf(obj) > -1) {
                            translatedValue += '*';
                        }
                    }
                    translatedValue = translatedValue ? translatedValue : translatedText;
                    if (jsonObject.schema.properties[obj].placeholder) {
                        jsonObject.schema.properties[obj].placeholder = translatedValue;
                    } else if (jsonObject.schema.properties[obj].selectText) {
                        jsonObject.schema.properties[obj].selectText = translatedValue;
                    }
                    // Unique Validation Message Translation
                    if (jsonObject.schema.properties[obj].uniqueValidationMessage) {
                        const errorTranslatedText = jsonObject.schema.properties[obj].uniqueValidationMessage;
                        const errorTranslatedValue = this._translateService.get('schemaform.' + errorTranslatedText)['value'];
                        jsonObject.schema.properties[obj].uniqueValidationMessage = errorTranslatedValue ?
                            errorTranslatedValue : errorTranslatedText;
                    }
                    // Translate Validation messages.
                    if (jsonObject.schema.properties[obj].validationMessages) {
                        const validationMessagesKeys = Object.keys(jsonObject.schema.properties[obj].validationMessages);
                        validationMessagesKeys.forEach((validationObj) => {
                            if (validationObj) {
                                const errorTranslatedText = jsonObject.schema.properties[obj].validationMessages[validationObj];
                                if (errorTranslatedText) {
                                    let errorTranslatedValue = this._translateService.get('schemaform.' + errorTranslatedText)['value'];
                                    errorTranslatedValue = errorTranslatedValue ? errorTranslatedValue : errorTranslatedText;
                                    jsonObject.schema.properties[obj].validationMessages[validationObj] = errorTranslatedValue ?
                                        errorTranslatedValue : errorTranslatedText;
                                }
                            }
                        });
                    }
                    if (this.isChangeRegisteredAddress) {
                        this.changeOptionGetUrl(jsonObject, obj);
                    }
                });
            }
        }
        // Translate Schema form Button Text.
        if (jsonObject && (jsonObject.form || jsonObject.layout)) {
            const jsonObjectForm = jsonObject.form || jsonObject.layout;
            for (let i = 0; i < jsonObjectForm.length; i++) {
                jsonObjectForm[i].items = this.searchButtonTitle(jsonObjectForm[i].items);
            }
        }
        return jsonObject;
    }

    /**
     * @description to set option get url
     * @date 2020-10-07
     * @param {*} jsonObject
     * @param {string} obj
     * @memberof AddressNewComponent
     */
    changeOptionGetUrl(jsonObject: any, obj: string): void {
        if (obj ===  SchemaProperty.STATE) {
            if (jsonObject.schema.properties[obj].optionGetUrl) {
                const optionGetUrl = jsonObject.schema.properties[obj].optionGetUrl
                    .replace(new RegExp('{countryId}', 'g'), this.countryId);
                jsonObject.schema.properties[obj].optionGetUrl = optionGetUrl;
            }
        }
        if (obj === SchemaProperty.COUNTRY) {
            if (jsonObject.schema.properties[obj].countryApiUrl) {
                jsonObject.schema.properties[obj].optionGetUrl = jsonObject.schema.properties[obj].countryApiUrl;
            }
            if (jsonObject.schema.properties[obj].disabled) {
                jsonObject.schema.properties[obj].disabled = false;
            }
        }
    }

    /** Search Button text
     * @param  {any} items
     */
    searchButtonTitle(items: any) {
        items.forEach(element => {
            if (element.title) {
                const translatedText = element.title;
                let translatedValue = this._translateService.get('schemaform.' + translatedText)['value'];
                translatedValue = translatedValue ? translatedValue : translatedText;
                element.title = translatedValue;
                // element.title = 'GET PICKUP LOCATIONS';
            }
            if(element.eventId=="VerifyAddress") {
                element.fieldHtmlClass = "hide verify-address";
            }
            // to disable Country field
            if (element.key && element.key === SchemaProperty.COUNTRY && this.isChangeRegisteredAddress) {
                element.disabled = false;
            }
            if (element.items instanceof Array) {
                const item = element.items;
                this.searchButtonTitle(item);
            }
        });
        return items;
    }

    /**
     * @returns void
     */
    findErrorElement(): void {
        setTimeout(() => {
            if (this.jsonFormObject && this.jsonFormObject.data) {
                this.addressInputChanged.emit(false);
            }  
            this.validationMessageInitialHide = false;
            if (document.getElementsByClassName('help-block').length > 0) {
                this.hideErrorElement(true);
            }
        }, 500);
    }

    /**
     * @param  {boolean} hide
     * @returns void
     */
    private hideErrorElement(hide: boolean): void {
        const elements = this.elementRef.nativeElement.getElementsByClassName('help-block');
        if (elements) {
            for (let i = 0; i < elements.length; i++) {
                if (hide) {
                    this._renderer.setElementClass(elements[i], 'hide', true);
                    this._renderer.setElementClass(elements[i], 'show', false);
                } else {
                    this._renderer.setElementClass(elements[i], 'show', true);
                    this._renderer.setElementClass(elements[i], 'hide', false);
                }
            }
        }
    }

    /**
     * to save address
     * and to emit the onsubmit output emmiter
     * @param  {any} address
     * @returns void
     */
    saveAddress(address: Address): void {
        if (address && this.liveFormStatus) {
            // To reset the address Input change after the user submit
            this.addressInputChanged.emit(false);
            this.address = this._commonService.trimObjectValues(address);
            if ((!this.addressVerificationForm || this.isAddressFormChanged) && !this.skipAddressVerification) {
                this.showAddressVerification = false;
                this.originalAddress = this.prepareNewAddress(address);
                if (this.checkoutConfig.displaySearchAddressSection) {
                    // this.originalAddress.disableAddressBlock =
                    // checkoutInformation && checkoutInformation.personalInformation
                    //  && checkoutInformation.personalInformation.isAutoPopulate ? true : false;
                    this.verifyAddressByDisplayName(this.originalAddress);
                } else {
                    this.getSuggestedAddress(this.originalAddress);
                }
            } else {
                this.processEnteredAddress(address);
            }
        } else {
            this.hideErrorElement(false);
        }
    }


    maskZipCode(): void {
        if (this.jsonFormObject && this.jsonFormObject.schema.properties
            && this.address) {
            const postalCode = this.address.zip || this.address.postalCode; 
                if (this.jsonFormObject.schema.properties.zip
                     && this.jsonFormObject.schema.properties.zip.maskFormat && postalCode) {
                    const zip = this._maskPipe.transform(postalCode, this.jsonFormObject.schema.properties.zip.maskFormat);
                    this.address.postalCode = zip;
                    this.address.zip = zip;
                }
        }
    }
    
    /**
     * @description get adderss
     * @param {Address} address
     * @returns {Address}
     * @memberof AddressNewComponent
     */
    prepareNewAddress(address: Address): Address {
        if (address) {
            let state: State;
            if (this.states && this.states.length > 0) {
                address = this.getStateByStateName(address);
                if (address.state) {
                    state = this.states.find(x => x.stateCode.toUpperCase() === address.state.toUpperCase());
                }
                if (!state) {
                    state = this.states[0];
                }
            }
            let country: Country;
            if (this.countries && this.countries.length > 0) {
                if (!address.country && !address.countryId) {
                    address.country = this.isoCountryCode;
                }
                country = this.countries
                    .find(x => x.countryId === (address.countryId ? address.countryId : Number(address.country)));
                if (!country && (typeof address.country === 'string')) {
                    country = this.countries
                        .find(x => x.isocodeThree.toLowerCase() === this.isoCountryCode.toLowerCase());
                }
            }
            if (this.checkoutConfig.displaySearchAddressSection && this.skipAddressVerification) {
                address.validAddress = true;
            }
            const mappedAddress: Address = {
                name: address.name,
                firstName: address.firstName,
                lastName: address.lastName,
                middleName: address.middleName,
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                addressLine3: address.addressLine3,
                addressLine4: address.addressLine4,
                city: address.city,
                state: state ? state.stateCode : '',
                stateId: state ? state.id : 0,
                stateCode: state ? state.stateCode : '',
                zip: address.zip || address.postalCode,
                postalCode: address.zip || address.postalCode,
                countryId: Number(address.country) || this.countryId,
                country: country ? country.isocodeThree : this.isoCountryCode,
                countryCode: country ? country.isocodeThree : this.isoCountryCode,
                addressVerified: address.addressVerified || address.validAddress,
                addressId: address.addressId,
                latitude: address.latitude,
                longitude: address.longitude,
                validAddress: address.validAddress,
                phone: address.phone ? address.phone : address.phoneNumber ? address.phoneNumber : null,
                phoneNumber: address.phone ? address.phone : address.phoneNumber ? address.phoneNumber : null,
                phoneType: address.phoneType,
                isShowStateCode :this.checkoutConfig.showStateCode,
                saveForFutureUse: address.saveForFutureUse,
                disableAddressBlock: address.disableAddressBlock,
                deliveryInstruction: address.deliveryInstruction,
                email : address.email ? address.email : null
            };
            return mappedAddress;
        }
    }

    /**
    * @description to get the suggested address and perform specific actions
    * @returns void
    */
    getSuggestedAddress(addressRequestObj: Address): void {
        this.responseCodes = [];
        this._addressService.getSuggestedAddress(addressRequestObj)
            .subscribe((verifyAddressResponse: Address) => {
                if (verifyAddressResponse) {
                    this.errorCodes = null;
                    this.errorCodesLength = null;
                    if (verifyAddressResponse.errorCodes && verifyAddressResponse.errorCodes.length > 0) {
                        verifyAddressResponse.errorCodes.forEach((code: VerifyAddressErrorCode) => {
                            verifyAddressResponse.saveForFutureUse = addressRequestObj.saveForFutureUse;
                            const responseCode: AddressResponse = {
                                responseCode: code.errorCode,
                                responseDescription: code.validationMessage
                            };
                            this.responseCodes.push(responseCode);
                        });
                         this.errorCodes = verifyAddressResponse.errorCodes.filter((x: any) =>
                            x.messageRequired === true && x.propertyName !== 'Note');
                        this.errorCodesLength = this.errorCodes.length;
                        this.errorCodes.forEach((code: VerifyAddressErrorCode) => {
                            if (code.shortDescription) {
                                let translatedValue = this._translateService.instant(
                                    decodeURIComponent(encodeURIComponent('checkout.' + code.errorCode + '_' + code.shortDescription)));
                                translatedValue = this._translateKey.transform(translatedValue, false);
                                code.shortDescription = translatedValue;
                            }
                        });
                        this.errorCodes = this.errorCodes.filter(x => x.shortDescription && x.shortDescription.length > 0);
                    }
                    if (this.errorCodesLength) {
                        this.addressVerificationForm = true;
                        this.isAddressFormChanged = false;
                        this.populateSuggestedAddress(verifyAddressResponse);
                        this.loadDesktopOrMobileAddressVerification(true);
                    } else if (verifyAddressResponse.sameAsSuggestedAddress) {
                        this.suggestedAddress = verifyAddressResponse;
                        this.suggestedAddress.zip = verifyAddressResponse.postalCode;
                        this.suggestedAddress.phone = this.originalAddress.phone
                            ? this.originalAddress.phone : null;
                        this.suggestedAddress.email = this.originalAddress.email
                            ? this.originalAddress.email : null;
                        this.selectedAddressType = AddressOptions.SUGGESTEDADDRESS;
                        if(this.originalAddress.deliveryInstruction){
                            this.suggestedAddress.deliveryInstruction = this.originalAddress.deliveryInstruction;
                        }
                        this.selectAddress();
                    } else if (this.participatingCountry) {
                        this.suggestedAddress = this.originalAddress;
                        this.selectedAddressType = AddressOptions.ORIGINALADDRESS;
                        this.selectAddress();
                    } else {
                        this.originalAddress = addressRequestObj;
                        this.addressVerificationForm = false;
                        this.suggestedAddress = verifyAddressResponse;
                        this.suggestedAddress.zip = verifyAddressResponse.postalCode;
                        this.suggestedAddress.phone = this.originalAddress.phone
                            ? this.originalAddress.phone : null;
                        this.suggestedAddress.email = this.originalAddress.email
                            ? this.originalAddress.email : null;
                            if(this.originalAddress.deliveryInstruction){
                                this.suggestedAddress.deliveryInstruction = this.originalAddress.deliveryInstruction;
                            }
                        this.getSchemaFormButton(false);
                        this.loadDesktopOrMobileAddressVerification(true);
                    }
                }

            }, (error) => {
                if(error.validations.find((validation:any) => validation.name.indexOf(AddressError.API_REQUEST_DAILY_LIMIT_EXCEED)===0)){
                    let message:String = error.validations[0].message;
                        let limit:String = message.replace(/[^0-9]/g,'');
                        let dailyLimitExceedMessage = this._translateService.get('common.'+'The Daily Limit of ||requestLimit|| is exceeded and address verification will not function')['value'];
                        dailyLimitExceedMessage = this._translateKey.transform(dailyLimitExceedMessage,{requestLimit: limit});
                        this._commonService.setNotification('',dailyLimitExceedMessage,NotificationType.ERROR,0,true,80);
                        this.addressSubmit.emit(this.originalAddress);
                }
                if (error.validations.find((validation: any) =>
                    validation.message.indexOf('Provider Information is not available for Country Code') === 0)) {
                        this.addressSubmit.emit(this.originalAddress);
                    }
            });
    }

    /**
     * @description method to populate suggested address
     * @param {Address} suggestedAddress
     * @memberof AddressNewComponent
     */
    populateSuggestedAddress(suggestedAddress: Address): void {
        if (suggestedAddress) {
            this.addressVerificationForm = false;
            if (!this.chRef['destroyed']) {
                this.chRef.detectChanges();
            }
            if (suggestedAddress.errorCodes && suggestedAddress.errorCodes.length > 0) {
                this.jsonFormObject = this.getCustomErrorMessages(suggestedAddress.errorCodes);
            }
            this.jsonFormObject = this.getSchemaFormButton(true);
            this.jsonFormObject.data =
                this.mapAddressToSchemaFields(this.originalAddress);
        } else {
            this.jsonFormObject.data = suggestedAddress;
        }
        this.addressVerificationForm = true;
        this.showAddressVerification = false;
        this.findErrorElement();
    }

    /**
     * once we click on verify button, show the 3 bttons and note block
     * and hide the verify button
     * @returns any
     */
    getSchemaFormButton(show: boolean): any {
        if (this.jsonFormObject && this.jsonFormObject.form) {
            const form: any = this.jsonFormObject.form.filter((x: any) => x.type === 'div');
            if (form && form.length) {
                const items: any = form[0].items;
                if (items && items.length) {
                    items.forEach((x: any) => {
                        if (x && x.items.length > 0) {
                            x.items.forEach((y: any) => {
                                if (y.eventId === 'UseOriginalAddress') {
                                    if (show) {
                                        y.fieldHtmlClass = 'show';
                                    } else {
                                        y.fieldHtmlClass = 'hide';

                                    }
                                }
                                if (y.eventId === 'VerifyAddress') {
                                    if (show) {
                                        y.fieldHtmlClass = 'show verify-address';
                                    } else {
                                        y.fieldHtmlClass = 'hide verify-address';

                                    }
                                }
                            });
                        }
                    });
                }
            }
        } else if (this.jsonFormObject && this.jsonFormObject.layout) {
            const layout: any = this.jsonFormObject.layout.find((x: any) => x.container === 'button');
            if (layout && layout.items) {
                layout.items.forEach((y: any) => {
                    if (y.eventId === 'UseOriginalAddress') {
                        if (show) {
                            y.fieldHtmlClass = 'show';
                        } else {
                            y.fieldHtmlClass = 'hide';

                        }
                    }
                    if (y.eventId === 'VerifyAddress') {
                        if (show) {
                            y.fieldHtmlClass = 'show verify-address';
                        } else {
                            y.fieldHtmlClass = 'hide verify-address';

                        }
                    }
                });
            }
        }
        return this.jsonFormObject;
    }

    /**
     * @description disable verify button after the address selection
     * @date 2018-11-28
     * @returns
     * @memberof AddressNewComponent
     */
    disableVerifyButton() {
        if (this.jsonFormObject && this.jsonFormObject.form) {
            const formItems = this.jsonFormObject.form.filter(x => x.type === 'div');
            if (formItems && formItems.length) {
                formItems.forEach(x => {
                    if (x && x.items && x.items.length > 0) {
                        x.items.forEach(y => {
                            if (y && y.items && y.items.length) {
                                y.items.forEach(z => {
                                    if (z.eventId === 'VerifyAddress') {
                                        z.disabled = true;
                                    }
                                });
                            }

                        });
                    }
                });
            }
        } else if (this.jsonFormObject && this.jsonFormObject.layout) {
            const layout = this.jsonFormObject.layout.find(x => x.container === 'button');
            if (layout && layout.items) {
                layout.items.forEach(z => {
                    if (z.eventId === 'VerifyAddress') {
                        z.disabled = true;
                    }
                });
            }
        }
        return this.jsonFormObject;
    }

    /**
     * @description enable verify button after the address selection
     * @returns
     * @memberof AddressNewComponent
     */
    enableVerifyButton() {
        if (this.jsonFormObject && this.jsonFormObject.form) {
            const formItems: any = this.jsonFormObject.form.filter((x: any) => x.type === 'div');
            if (formItems && formItems.length) {
                formItems.forEach(x => {
                    if (x && x.items && x.items.length > 0) {
                        x.items.forEach(y => {
                            if (y && y.items && y.items.length) {
                                y.items.forEach(z => {
                                    if (z.eventId === 'VerifyAddress') {
                                        z.disabled = false;
                                    }
                                });
                            }
                        });
                    }
                });
            }
        } else if (this.jsonFormObject && this.jsonFormObject.layout) {
            const layout: any = this.jsonFormObject.layout.find((x: any) => x.container === 'button');
            if (layout && layout.items) {
                layout.items.forEach(z => {
                    if (z.eventId === 'VerifyAddress') {
                        z.disabled = false;
                    }
                });
            }
        }
        return this.jsonFormObject;
    }

    /**
     * to get error messages
     * @param  {any} errorCode
     */
    getCustomErrorMessages(errorCode: any): any {
        if (this.jsonFormObject && (this.jsonFormObject.form || this.jsonFormObject.layout)) {
            Object.keys(this.jsonFormObject.schema.properties).forEach((x, y) => {
                const errorProperty: any = errorCode.filter((z: any) => z.propertyName.toUpperCase() === x.toUpperCase());
                const schemaProperty: any = this.jsonFormObject.schema.properties[x];
                if (errorProperty.length > 0) {
                    schemaProperty.customErrorMessage = '';
                    errorProperty.forEach((error: any) => {
                        if (error.messageType === 'AddressCorrected') {
                            schemaProperty.customErrorMessage = '';
                            schemaProperty.htmlClass = 'color-green';
                        } else if (error.messageType === 'ErrorMessage') {
                            let translatedValue = this._translateService.get('schemaform.' + error.validationMessage)['value'];
                            translatedValue = translatedValue ? translatedValue : error.validationMessage;
                            schemaProperty.customErrorMessage = schemaProperty.customErrorMessage !== ''
                                && schemaProperty.customErrorMessage !== undefined ?
                                '<div>' + schemaProperty.customErrorMessage + '</div><div>' + translatedValue + '</div>'
                                : translatedValue;
                            schemaProperty.htmlClass = 'color-yellow';
                        }
                    });
                } else {
                    schemaProperty.customErrorMessage = '';
                }
            });
        }
        return this.jsonFormObject;
    }

    /**
    * @param  {any} address
    * @returns any
    */
    private mapAddressToSchemaFields(address: Address): Address {
        if (address) {
            const mapSchemaFields: Address = {
                firstName: address.firstName,
                middleName: address.middleName,
                lastName: address.lastName,
                name: address.name || address.shipToName,
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                addressLine3: address.addressLine3,
                addressLine4: address.addressLine4,
                city: address.city,
                state: address.stateCode || address.state,
                zip: address.zip || address.postalCode || address.zipCode,
                country: String(address.countryId),
                phone: address.phoneNumber ? address.phoneNumber : address.phone ? address.phone :  null,
                phoneType: address.phoneType,
                saveForFutureUse: address.saveForFutureUse || address.isSavedAddress,
                isSavedAddress: address.isSavedAddress,
                disableAddressBlock: address.disableAddressBlock,
                deliveryInstruction: address.deliveryInstruction,
                email: address.email ? address.email : null
            };
            return mapSchemaFields;
        }

    }

    /**
     * Store the selected address type
     * @param selectedAddressType
     */
    setAddressType(selectedAddressType: AddressOptions) {
        this.selectedAddressType = selectedAddressType;
    }

    /**
     * select Address
     */
    selectAddress(isPreventReload?: boolean) {
        if (this.selectedAddressType === AddressOptions.ORIGINALADDRESS) {
            this.getJsonSchema(this.originalAddress);
            this.emitEnteredAddress(this.originalAddress);
        } else if (this.selectedAddressType === AddressOptions.SUGGESTEDADDRESS) {
            this.suggestedAddress.name = this.originalAddress.name;
            this.suggestedAddress.firstName = this.originalAddress.firstName;
            this.suggestedAddress.middleName = this.originalAddress.middleName;
            this.suggestedAddress.lastName = this.originalAddress.lastName;
            this.suggestedAddress.phoneType = this.originalAddress.phoneType;
            if (this.originalAddress && this.originalAddress.country === this.suggestedAddress.country
                && this.originalAddress.countryId) {
                this.suggestedAddress.countryId = this.originalAddress.countryId;
            }
            if (this.checkoutConfig && !this.checkoutConfig.loadParticipatingCountries) {
            this.suggestedAddress.countryId = this.originalAddress.countryId;
            }
            this.getJsonSchema(this.suggestedAddress);
            this.emitEnteredAddress(this.suggestedAddress);
        }
        this.loadDesktopOrMobileAddressVerification(false);
    }

    /**
     * @description this method is used
     * emit entered address from child to parent
     * component
     * @date 2018-07-20
     * @memberof AddressComponent
     */
    emitEnteredAddress(address: Address): void {
        if (address && !this.skipAddressVerification) {
            this.preloadAddress = null;
            this.getJsonSchema(address);
            this._appMessageService.setPUDOSuggestedAddress(address);
        }
        this.address = this.prepareNewAddress(address);
        if (this.checkoutConfig.displaySearchAddressSection) {
            this.getSpatialInfo();
        } else {
            this.addressSubmit.emit(this.address);
        }
    }

    /**
     * to perform actions on click of each button
     * @param  {any} event
     * @returns void
     */
    verifyButtonSubmit(event: any): void {
        if (event.eventId === 'UseOriginalAddress' && this.liveFormStatus) {
            this.processEnteredAddress(this.liveFormData);
        } else if (event.eventId === 'Cancel' && this.isChangeRegisteredAddress) {
            this.cancelChangeAddress.emit(true);
        } else {
            this.hideErrorElement(false);
        }
    }

    /**
     * @description this method ued to
     * emit address from child to parent
     * component while
     * @date 2018-07-23
     * @param {Address} address
     * @memberof AddressComponent
     */
    processEnteredAddress(address: Address): void {
        this.addressVerificationForm = false;
        this.hideErrorElement(true);
        const existingAddress: Address = this.prepareNewAddress(address);
        this.emitEnteredAddress(existingAddress);
        this.loadDesktopOrMobileAddressVerification(false);
        if (existingAddress && existingAddress.addressVerified) {
            this.jsonFormObject = this.disableVerifyButton();
            if (this.skipAddressVerification && this.checkoutConfig.displaySearchAddressSection) {
                this.disableAddressFields(true);
            }
        }
        this.hideErrorElement(false);
    }

    /**
     * @returns void
     */
    onHidden(): void {
        this.getSchemaFormButton(false);
    }

    /**
    * re bind form when we click on change address
    * @returns void
    */
    rebindForm(): void {
        this.editSubscription = this._commonService.getEmitter('editAddress')
            .subscribe((response: any) => {
                this.getJsonSchema(response);
                this.jsonFormObject.data = response;
                if (response && !response.isSavedAddress) {
                    if (!this.chRef['destroyed']) {
                        this.chRef.detectChanges();
                    }
                    this.addressVerificationForm = true;
                    this.loadDesktopOrMobileAddressVerification(true);
                }
            });
    }

    /**
     * @description this method will be used
     * to load address verification based on mobile or desktop devices
     * @date 2018-08-02
     * @private
     * @memberof AddressComponent
     */
    private loadDesktopOrMobileAddressVerification(displayVerification: boolean): void {
        this.displayAddressBlock = displayVerification;
        this.addressHidden.emit(this.displayAddressBlock);
        if (displayVerification) {
            if (!this.isModalOpen) {
                this.isModalOpen = true;
                this.addressModal.closeOnOutsideClick = false;
                this.addressModal.closeOnEscape = false;
                this.addressModal.open();
            }
        } else {
            this.isModalOpen = false;
            this.jsonFormObject = this.getParsedSchemaFormJson(this.originalJsonFormObject);
            if (this.address && this.address.countryId) {
                this.address.country = String(this.address.countryId);
            }
            this.jsonFormObject.data = this.mapAddressToSchemaFields(this.address);
            if (this.skipAddressVerification && this.checkoutConfig.displaySearchAddressSection) {
                this.disableAddressFields(true);
            }
            if(this.addressModal) {
                this.addressModal.close();
            }
        }
        if (!this.displayAddressBlock) {
            setTimeout(() => {
                this.displayAddressBlock = true;
                this.addressHidden.emit(this.displayAddressBlock);
            }, 100);
        }
    }

    /**
     *Edit the Address
     * @param {Address} originalAddress
     * @memberof AddressComponent
     */
    editAddress(originalAddress: Address) {
        this.addressVerificationForm = true;
        this.getJsonSchema(originalAddress, true);
        this.jsonFormObject.data = originalAddress;
        this.showAddressVerification = true;
    }

    /**
     * @description this method will get status of form
     * @date 2018-10-10
     * @memberof AddressNewComponent
     */
    liveFormDataIsValid(formStatus: boolean): void {
        this.liveFormStatus = formStatus;
        this.addressIsValid.emit(formStatus);
    }

    /**
    * @description this method will mask phone number based on country format
    * @date 2018-11-13
    * @private
    * @memberof AddressComponent
    */
    private maskPhoneNumber(phone: string): string {
        const phoneNumberFormat= this._commonService.getPhoneNumberFormatByCountryCode(this.countryCode)
        if (phone) {
            if(phoneNumberFormat){
                return this._maskPipe.transform(phone, phoneNumberFormat);  
            }else{
             return phone;  
            }
        }
    }

    /**
     * @description
     * @date 2020-05-02
     * @private
     * @memberof AddressNewComponent
     */
    private getCustomSelectOption(): void {
        this.customSelectSubscription = this.messageService.getCustomSelect()
            .subscribe((countryId: string) => {
                if (countryId) {
                    const selectedCountry = this.countries
                        .find((x: Country) => x.countryId === parseInt(countryId, 10));
                    if (selectedCountry) {
                        this.isoCountryCode = selectedCountry.isocodeThree.toLowerCase();
                        this.countryCode = this.isoCountryCode;
                        this.countryId = selectedCountry.countryId;
                        if (this.countryId) {
                            this.getStatesByCountry(this.countryId);
                        }
                        if (this.isChangeRegisteredAddress) {
                            this.changeSchemaForm(selectedCountry);
                    }
                        if (this.isShippingAddressSchemaform && this.checkoutConfig && this.checkoutConfig.changeSchemaFormOnCountryChange) {
                            this.changeSchemaOnCountryChange(false, selectedCountry);
                        }
                }
                }
                this.pollCount = 0;
            });
    }

    /** disable schema address form fields
    * @param  {any} jsonObject
    */
    disableAddressFields(isDisable?: boolean): void {
        if (!this.addressVerificationForm && isDisable) {
            setTimeout(() => {
                const schemaClass = '.' + this.schemaClass;
                const addressElements: any = document.querySelectorAll
                (schemaClass + ' .disable_field input,' + schemaClass + ' .disable_field select');
                if (addressElements && this.checkoutConfig.displaySearchAddressSection) {
                    for (let i = 0; i < addressElements.length; i++) {
                        addressElements[i].disabled = true;
                    }
                }
            }, 500);
        }
    }

    /**
   * for pudo locations we disable 
   * country dropdown only for SWE, DNK, NOR and FIN,
   * as we have no pudo locations
   */
  disableCountryDropdownForPudoPickup() {
      setTimeout(() => {
        const countryDropdownElements: any = document.querySelectorAll('.disable_country_field select');
        if (countryDropdownElements) {
          for (let i = 0; i < countryDropdownElements.length; i++) {
            countryDropdownElements[i].disabled = true;
          }
        }
      }, 500);
  }

    /**
     * @description to get New Schema-Form Based on Country code when We change Country
     * @author Akhil
     * @date 2021-04-08
     * @param {boolean} [onLoad]
     * @param {*} [selectedCountry]
     * @memberof AddressNewComponent
     */
    changeSchemaOnCountryChange(onLoad?: boolean, selectedCountry?: any) {
        let address = null;
        let countryCode = null;

        if (!onLoad) {
            address = this.liveFormData;
            countryCode = selectedCountry ? selectedCountry.isocodeThree : null;
        } else {
            address = this.address || this.preloadAddress;
            countryCode = address ? address.countryCode : null;
        }
        if (address) {
            if (countryCode) {
                if (this.isShippingAddressSchemaform) {
                    this.schemaUrl = countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                        + environment.templateVersion;
                }
            }
        }
        if (!onLoad && this.liveFormData) {
            this.liveFormData.state = "";
            this.liveFormData.countryId = this.countryId;
            this.getJsonSchema(this.liveFormData);
        }
    }

    /**
     * To enable the address fields when click on don't match address link
     * @returns void
     */
    enableAddressFields(): void {
        this.enableAddressFieldSubscription = this.messageService.getEnableAddressFields().subscribe(addressInfo => {
            if (addressInfo.isEnableAddressFields) {
                this.skipAddressVerification = false;
                const elements: any = document.querySelectorAll('.' + addressInfo.block + ' .disable_field input, .disable_field select');
                if (elements) {
                    for (let i = 0; i < elements.length; i++) {
                        elements[i].disabled = false;
                    }
                }
            }
        });
    }

    /**
     * getStateByStateName()
     * @param address
     */
    private getStateByStateName(address?: Address): Address {
        if (this.states && this.states.length > 0
            && this.checkoutConfig.findStateByStateName && address && address.state) {
            let state = this.states.find(x => x.stateName.toLowerCase() === address.state.toLowerCase());
            if(!state){  
                state= this.states.find(x =>x.stateName?address.state.toLowerCase().indexOf(x.stateName.toLowerCase())>-1:null);
            }  
            if (state && state.stateCode) {
                address.state = state.stateCode;
                address.stateCode = state.stateCode;
            }
        }
        return address;
    }


    /**
     * To avoid MemoryLeaks need to unsubscribe.
     */
    ngOnDestroy() {
        this.chRef.detach();
        if (this.editSubscription) {
            this.editSubscription.unsubscribe();
        }
        if (this.submitAddressSubscription) {
            this.submitAddressSubscription.unsubscribe();
        }
        if (this.customSelectSubscription) {
            this.customSelectSubscription.unsubscribe();
        }
        if (this.enableAddressFieldSubscription) {
            this.enableAddressFieldSubscription.unsubscribe();
        }
        if(this.resetFormDataSubscription) {
            this.resetFormDataSubscription.unsubscribe();
        }
    }

    /**
     * @description get adderss
     * @param {Address} address
     * @returns {Address}
     * @memberof AddressNewComponent
     */
    prepareAddressObject(address) {
        if (address) {
            let res;
            this._customerService.getStatesByCountryId(address.countryId).toPromise().then((result) => {
                res = result;
            });
            let state: State;
                if (res) {
                    state = res[0];
                } else {
                    if (this.states && this.states.length > 0) {
                        if (address.state) {
                            state = this.states.find(x => x.stateCode.toUpperCase() === address.state.toUpperCase());
                        }
                        if (!state) {
                            state = this.states[0];
                        }
                    }
                }
                address.state = address.state ? address.state : (state ? state.stateCode : '');
                address.stateId = state ? state.id : 0;
                address.stateCode = state ? state.stateCode : '';
                return address;
        }
    }

    /**
     * @description to chanage schema form based on selected country
     * @date 2020-10-07
     * @param {*} selectedCountry
     * @memberof AddressNewComponent
     */
    changeSchemaForm(selectedCountry: any): void {
        if (selectedCountry) {
            let country = 'gbl';
            this.loadCheckoutConfig(selectedCountry);
            if (this.checkoutConfig) {
                this.isDisplaySearchAddressSection.emit(this.checkoutConfig.displaySearchAddressSection);
                country = this.checkoutConfig.loadParticipatingCountries && selectedCountry.associatedCountryCodeThree ?
                selectedCountry.associatedCountryCodeThree : selectedCountry.isocodeThree;
            }
            this.schemaUrl = country.toLowerCase() +
                    '-mailing-schema-form.json?templateVersion=' + environment.templateVersion;
            this.liveFormData.state = '';
            this.liveFormData.countryId = this.countryId;
            this.getJsonSchema(this.liveFormData);
        }
    }

    /**
     * @description to load checkout config based on selected country
     * @date 2020-10-07
     * @param {*} selectedCountry
     * @memberof AddressNewComponent
     */
    loadCheckoutConfig(selectedCountry: any): void {
        if (selectedCountry) {
            let countryCode: string;
            let selectedCountryCode: string;
            if (selectedCountry.associatedCountryCodeThree) {
                countryCode = selectedCountry.associatedCountryCodeThree;
            } else {
                countryCode = selectedCountry.isocodeThree;
            }
            if (countryCode) {
                this.checkoutConfig = this._checkoutConfigService.getSettings(countryCode, null);
                selectedCountryCode = countryCode;
            }
            if (!this.checkoutConfig.loadParticipatingCountries) {
                this.checkoutConfig = this._checkoutConfigService.getSettings(selectedCountry.isocodeThree, null);
                selectedCountryCode = selectedCountry.isocodeThree;
            }
            if (selectedCountryCode && this.checkoutConfig.displaySearchAddressSection) {
                this.messageService.setSelectedCountry(selectedCountryCode);
            }
        }
    }
    
    getSubmitAddress(){
        this.submitAddressSubscription = this._appMessageService.getSubmitPudoPickupPersonAddress().subscribe((isSubmit: boolean) => {
            if (isSubmit) {
                const element = this.elementRef.nativeElement.getElementsByClassName('verify-address');
                if (element && element[0]) {
                    element[0].click();
                }
            }
        });
        this.submitAddressSubscription = this._appMessageService.getSubmitDropShipPersonAddress().subscribe((isSubmit: boolean) => {
            const element = this.elementRef.nativeElement.getElementsByClassName('verify-address');
            if (element && element[0]) {
                element[0].click();
            }
        });
    }

    getRebindform() {
        this._appMessageService.getSubmitDropShipPersonAddress().subscribe((isSubmit: boolean) => {
            this.rebindForm();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/address/pudo-address.component.ts